import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import * as luxon from 'luxon';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
    selector: 'app-edit-button',
    templateUrl: './edit-button.component.html',
    styleUrls: ['./edit-button.component.scss'],
    standalone: false // NOSONAR
})
export class EditButtonComponent {
  @Input() name: string;
  private params: any;
  eventId: any;
  faGlass = faMagnifyingGlass;
  isEvent: boolean = false;
  lastUpdatedDate: any = false;
  updateTrigger: boolean = false;
  snoozeDelay: boolean = false;
  snoozeTime: any;
  isAccessible: boolean = true
  className: string = 'no-blink';
  routeArrived: boolean = false;

  constructor(
      private readonly dialog : MatDialog,
     private readonly router : Router,
     private  readonly dashboardService : DashboardService,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    private readonly  DatePipe: DatePipe,
     private readonly aetStateService : AetStateService,
    public constants: Constants
  ) {}

  agInit(params: any): void {
    // this.checkRoles();
    this.params = params;
    this.isEvent = this.params.data?.event_id ? true : false;
    this.lastUpdatedDate = this.params.data?.last_updated;
    this.snoozeTime = this.params.data?.snooze_time;

    const today = luxon.DateTime.now().toMillis();
    if (this.lastUpdatedDate !=   null && this.params.data?.updateTrigger !=   0) {   // NOSONAR
      const test = luxon.DateTime.fromFormat(
        this.lastUpdatedDate.substring(0, 16),
        'MM/dd/yyyy HH:mm',
        {
          zone: this.constants.timeZones[
            this.lastUpdatedDate.substring(18, 21)
          ],
          setZone: true,
        }
      ).toMillis();
      if (today - test > this.params.data?.updateTrigger * 60 * 1000) {
        this.updateTrigger = true;
        // console.info('2nd condition is true', this.updateTrigger)
      }
    }
    this.routeArrived = this.params.data?.route_status == 'Arrived';    // NOSONAR

    if (this.snoozeTime == null && this.params.data?.snoozeDelay !=   0) {    // NOSONAR
      this.snoozeDelay = true;
    } else if (this.snoozeTime !=   null && this.params.data?.snoozeDelay !=   0) {    // NOSONAR
      const test = luxon.DateTime.fromFormat(
        this.snoozeTime,
        'MM-dd-yyyy HH:mm:ss',
        { zone: 'UTC', setZone: true }
      ).toMillis();
      if (today - test > this.params.data?.snoozeDelay * 60 * 1000) {
        this.snoozeDelay = true;
      }
    }

    this.className =
      this.snoozeDelay && this.updateTrigger && !this.routeArrived
        ? 'editBtn me-2 start-blink'
        : 'editBtn me-2 no-blink';
  }

  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON?.parse(roles);
    if (
      userRoles &&
      (userRoles.includes(this.constants.LIOS_UAC_Admin) ||
        userRoles.includes(this.constants.LIOS_UAC_AET_Admin) ||
        userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
        userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
        userRoles.includes(this.constants.LIOS_UAC_MTMUS_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_MTMUS_Negotiator) ||
        userRoles.includes(this.constants.LIOS_UAC_Portal_Administrator) ||
        userRoles.includes(this.constants.LIOS_UAC_Reporting_Admin) ||
        userRoles.includes(this.constants.LIOS_UAC_Reporting_User) ||
        userRoles.includes(this.constants.LIOS_UAC_Route_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_SCV_Admin) ||
        userRoles.includes(this.constants.LIOS_UAC_Security_Admin) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_AF) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_Budgeting) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_AM) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_Purchasing) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_LC) ||
        userRoles.includes(this.constants.LIOS_UAC_TPT_Admin) ||
        userRoles.includes(this.constants.LIOS_UAC_TSCS_Admin) ||
        userRoles.includes(this.constants.LIOS_UAC_WT_Administrator))
    ) {
      this.isAccessible = true;
    } else {
      this.isAccessible = false;
    }
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   // this.isAccessible = true;
    // } else {
    //   this.router.navigate([`/home`]);
    // }
  }

  snoozeMethod(event: MouseEvent) {
    event.stopPropagation();
    console.info('event by clicking the snooze', this.params.data?.event_id);
    this.dashboardService.snoozeCall(this.params.data.event_id).subscribe(
      (_res) => {
        this.params?.context.componentParent.gridDataFetch();
      },
      (error) => {
        console.info(error);
      }
    );
  }
  openEventDetails() {
    this.eventId = this.params.data?.event_id;
    localStorage.setItem('eventId', this.eventId);
    localStorage.setItem('route', this.params.data?.main_route.split('-')[0]);
    localStorage.setItem('run', this.params.data?.main_route.split('-')[1]);
    localStorage.setItem(
      'arrival',
      this.params.data?.unload_start.substring(0, 10)
    );
    localStorage.setItem('region', this.params.data?.region);
    this.router?.navigate(['/dashboard/event']);
  }

  btnHandler(event: MouseEvent) {
    event.stopPropagation();
    this.params?.context.componentParent.editEvent(this.params.data);
  }
}
